// this dir contains page building blocks like Header and Grid layout
// and some common pages like NotFound

export { default as Header } from './Header';
export { default as Page } from './Page';
export { default as Body } from './Body';
export { default as NotFound } from './NotFound';
